import { Dispatch } from "redux";
import { ShipmentTypes } from "../types";
import { ShipmentsProcess } from "../../api/process";

export const getShipmentsByDateRangeAction =
    (dateFrom: string, dateTo: string) =>
    async (dispatch: Dispatch) => {
        try {
            dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_LOADING,
                payload: { loadingByDateRange: true },
            });

            const shipmentsProcess = new ShipmentsProcess();
            const response = await shipmentsProcess.getShipmentsByDateRange(
                dateFrom,
                dateTo
            );

            return dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_SUCCESS,
                payload: {
                    data: response.data || [],
                    success: true,
                },
            });
        } catch (error) {
            return dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_FAILURE,
                payload: { successByDateRange: false },
            });
        }
    };

export const getShipmentsOverviewAction =
    (year: number) => async (dispatch: Dispatch) => {
        try {
            dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_OVERVIEW_LOADING,
                payload: { loadingOverview: true },
            });

            const shipmentsProcess = new ShipmentsProcess();
            const response = await shipmentsProcess.getShipmentsOverview(year);

            return dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_OVERVIEW_SUCCESS,
                payload: {
                    data: response.data || [],
                    success: true,
                },
            });
        } catch (error) {
            return dispatch({
                type: ShipmentTypes.GET_SHIPMENTS_OVERVIEW_FAILURE,
                payload: { successOverview: false },
            });
        }
    };
